import { render } from "./paramChangeRequest.vue?vue&type=template&id=5bbfba76&scoped=true"
import script from "./paramChangeRequest.vue?vue&type=script&lang=js"
export * from "./paramChangeRequest.vue?vue&type=script&lang=js"

import "./paramChangeRequest.vue?vue&type=style&index=0&id=5bbfba76&scoped=true&lang=css"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbfba76"]])

export default __exports__